export default "__VITE_ASSET__VCavm3jc__"